import axios from "axios";
import { getAuthHeader } from "./auth";
import { API_BASE_URL } from "./config";

// 使用配置文件或环境变量中的API基础URL，默认使用后端API默认地址
const API_URL = API_BASE_URL || "http://localhost:8200";

// 用户相关API
export const fetchUsers = async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/auth/users`, {
        headers: getAuthHeader(),
        params: params,
    });
    return response.data;
};

export const fetchUser = async (userId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/users/${userId}`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const createUser = async (userData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/auth/users`, userData, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("创建用户错误:", error);
        if (error.response && error.response.data) {
            console.error("错误详情:", error.response.data);
        }
        throw error;
    }
};

export const updateUser = async (userId, userData) => {
    const response = await axios.put(`${API_BASE_URL}/auth/users/${userId}`, userData, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const deleteUser = async (userId) => {
    const response = await axios.delete(`${API_BASE_URL}/auth/users/${userId}`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const resetUserPassword = async (userId, newPassword) => {
    const response = await axios.post(
        `${API_BASE_URL}/auth/users/${userId}/reset-password`,
        { new_password: newPassword },
        {
            headers: getAuthHeader(),
        },
    );
    return response.data;
};

export const assignUserRoles = async (userId, roleData) => {
    const response = await axios.post(`${API_BASE_URL}/auth/users/${userId}/roles`, roleData, {
        headers: getAuthHeader(),
    });
    return response.data;
};

// 角色相关API
export const fetchRoles = async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/auth/roles`, {
        headers: getAuthHeader(),
        params: params,
    });
    return response.data;
};

export const fetchRole = async (roleId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/roles/${roleId}`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const createRole = async (roleData) => {
    const response = await axios.post(`${API_BASE_URL}/auth/roles`, roleData, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const updateRole = async (roleId, roleData) => {
    const response = await axios.put(`${API_BASE_URL}/auth/roles/${roleId}`, roleData, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const deleteRole = async (roleId) => {
    const response = await axios.delete(`${API_BASE_URL}/auth/roles/${roleId}`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

// 权限相关API
export const fetchPermissions = async () => {
    const response = await axios.get(`${API_BASE_URL}/auth/permissions`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const fetchRolePermissions = async (roleId) => {
    const response = await axios.get(`${API_BASE_URL}/auth/roles/${roleId}/permissions`, {
        headers: getAuthHeader(),
    });
    return response.data;
};

export const assignRolePermissions = async (roleId, permissionData) => {
    const response = await axios.post(`${API_BASE_URL}/auth/roles/${roleId}/permissions`, permissionData, {
        headers: getAuthHeader(),
    });
    return response.data;
};
